
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import filtros from './lista-buscador-filtros.vue';
    import cuentas from './lista-buscador-cuentas.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            filtros,
            cuentas,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtros() { return this.Controlador.Buscador.Filtros; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }

        public Abierto: boolean = false;

        Seleccionar( x: number )
        {
            if ( this.Filtros.Valores.Limite == x )
                return;
            this.Filtros.Valores.Limite = x;
            this.Buscador.Buscar( 1 );
            this.Refrescar();
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        public Busqueda: string = '';
        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
            this.Buscador.Filtros.Busqueda = this.Busqueda;
            this.Buscador.Buscar( 1 );
        }
    }
